import { useContext } from 'react'
import { FidelityContext } from '../../context/FidelityContext'

export const useFidelityTabs = () => {
  const { tabsEnums, getCurrentTab, handleChangeTab } =
    useContext(FidelityContext)

  const filterCollection = [
    {
      key: `fidelity-tab-${tabsEnums.WALLET}`,
      value: tabsEnums.WALLET,
      name: 'Carteira',
      icon: 'wallet',
    },
    {
      key: `fidelity-tab-${tabsEnums.STATEMENT}`,
      value: tabsEnums.STATEMENT,
      name: 'Extrato',
      icon: 'receipt',
    },
    {
      key: `fidelity-tab-${tabsEnums.CAMPAIGN}`,
      value: tabsEnums.CAMPAIGN,
      name: 'Campanhas',
      icon: 'dynamic_feed',
    },
  ]

  const getActiveTab = ({ value }) => {
    if (value !== getCurrentTab()) return false
    return true
  }

  return { filterCollection, getActiveTab, handleChangeTab }
}
